// extracted by mini-css-extract-plugin
export var content = "_m2-1";
export var fullScreen = "_m2-0";